import { React, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DownloadStatusSpinner from "../../../../components/DownloadStatusSpinner/DownloadStatusSpinner";
import { InterviewService } from "../../../../services/InterviewService";
import { DocOnlineDocumentLine } from "./DocOnlineDocumentLine";

export function DocOnlineDocuments({
  interviewId,
  updateDocumentsGrid,
  disabled,
  interview
}) {
  const { t } = useTranslation();
  const [docOnlineDocuments, setDocOnlineDocuments] = useState([]);
  const [docOnlineDownloadStatus, setDocOnlineDownloadStatus] = useState({
    statusName: "done",
    errorCaught: false
  });
  const [isAccordionCollapsed, setIsAccordionCollapsed] = useState(true);

  useEffect(() => {
    getDocOnlineSubmitted();
  }, [updateDocumentsGrid]);
  function getDocOnlineSubmitted() {
    if (interviewId > 0) {
      InterviewService.getDocOnlineSubmitted(Number(interviewId)).then(
        (docOnline) => {
          if (docOnline !== undefined && docOnline.length > 0) {
            setDocOnlineDocuments(docOnline);
          } else {
            setDocOnlineDocuments([]);
          }
        }
      );
    }
  }
  return (
    <>
      {((disabled && docOnlineDocuments.length > 0) || !disabled) && (
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingDocOnline">
            {!disabled ? (
              <button
                className={`accordion-button ${
                  isAccordionCollapsed && docOnlineDocuments.length === 0
                    ? "collapsed"
                    : isAccordionCollapsed && docOnlineDocuments.length > 0
                    ? ""
                    : !isAccordionCollapsed && docOnlineDocuments.length > 0
                    ? "collapsed"
                    : isAccordionCollapsed
                    ? "collapsed"
                    : ""
                }`}
                type="button"
                data-bs-target="#collapseDocOnline"
                aria-expanded="false"
                aria-controls="collapseDocOnline"
                onClick={() => setIsAccordionCollapsed(!isAccordionCollapsed)}
              >
                DocOnline
              </button>
            ) : (
              <label className={"accordion-button label-documents"}>
                DocOnline
              </label>
            )}
          </h2>
          {!disabled ? (
            <div
              id="collapseDocOnline"
              className={`accordion-collapse ${
                isAccordionCollapsed && docOnlineDocuments.length === 0
                  ? "collapse"
                  : isAccordionCollapsed && docOnlineDocuments.length > 0
                  ? ""
                  : !isAccordionCollapsed && docOnlineDocuments.length > 0
                  ? "collapse"
                  : isAccordionCollapsed
                  ? "collapse"
                  : ""
              }`}
              aria-labelledby="headingDocOnline"
              data-bs-parent="#accordionFlushDocuments"
            >
              <div class="accordion-body table-wrap documents-tab-doconline margim-table-documents">
                <DownloadStatusSpinner
                  downloadStatus={docOnlineDownloadStatus.statusName}
                  errorCaught={docOnlineDownloadStatus.errorCaught}
                  textPending={t("Downloading")}
                  textDone={t("Done")}
                />
                <table className="table mt-2">
                  <thead>
                    <th className="languages">{t("Language")}</th>
                    <th className="description">{t("Description")}</th>
                    <th className="updated-date">{t("Updated on")}</th>
                    <th className="updated-date">{t("Modified")}</th>
                    <th className="actions">{t("Actions")}</th>
                  </thead>
                  <tbody>
                    <DocOnlineDocumentLine
                      docsOnline={docOnlineDocuments}
                      setDocOnlineDownloadStatus={setDocOnlineDownloadStatus}
                      docOnlineDownloadStatus={docOnlineDownloadStatus}
                      setDocsOnline={setDocOnlineDocuments}
                      disabled={disabled}
                      interviewId={interviewId}
                      deleteCallBack={getDocOnlineSubmitted}
                      interview={interview}
                    />
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div
              id="collapseDocOnline"
              className="accordion-collapse"
              aria-labelledby="headingDocOnline"
              data-bs-parent="#accordionFlushDocuments"
            >
              <div class="accordion-body table-wrap documents-tab-doconline margim-table-documents">
                <DownloadStatusSpinner
                  downloadStatus={docOnlineDownloadStatus.statusName}
                  errorCaught={docOnlineDownloadStatus.errorCaught}
                  textPending={t("Downloading")}
                  textDone={t("Done")}
                />
                <table className="table mt-2">
                  <thead>
                    <th className="languages">{t("Language")}</th>
                    <th className="description">{t("Description")}</th>
                    <th className="updated-date">{t("Updated on")}</th>
                    <th className="updated-date">{t("Modified by")}</th>
                    <th className="actions">{t("Actions")}</th>
                  </thead>
                  <tbody>
                    <DocOnlineDocumentLine
                      docsOnline={docOnlineDocuments}
                      setDocOnlineDownloadStatus={setDocOnlineDownloadStatus}
                      setDocsOnline={setDocOnlineDocuments}
                      docOnlineDownloadStatus={docOnlineDownloadStatus}
                      disabled={disabled}
                    />
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
